<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<h4 mat-dialog-title i18n="@@removalSummary">Removal summary</h4>

<div mat-dialog-content>
  <form [formGroup]="removalFG" #rForm="ngForm" (ngSubmit)="removalFormSubmit()">
    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-display-removal-point-details [data]="externalRemoval?._embedded?.removalPoint" [oneLine]="true">
        </app-display-removal-point-details>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-table-validate-animals [data]="externalAnimals" (needPayment)="needPayment($event)">
        </app-table-validate-animals>
      </div>
    </div>

    <div class="row mb-3" *ngIf="externalRemoval?.comments">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <p class="font-15 text-uppercase">{{externalRemoval?.comments}}</p>
      </div>
    </div>

    <div class="row mb-2" *ngIf="hasAnimalNotAdded">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-display-animals-not-added [externalRemoval]="externalRemoval" [submittedRemoval]="submittedRemoval">
        </app-display-animals-not-added>
      </div>
    </div>

    <div class="row" *ngIf="showDocsToGive">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title" i18n="@@docsToGive">Documents to be provided during the removal</div>
          </div>

          <div class="ibox-body">
            <app-display-docs-to-give [data]="externalRemoval" (display)="hasDocsToGive($event)">
            </app-display-docs-to-give>
          </div>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="showChoicePayment">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="ibox">
          <div class="ibox-head">
            <div class="ibox-title" i18n="@@choicePayment">Choice payment</div>
          </div>

          <div class="ibox-body">
            <app-select-payment controlName="paymentType" [showLabel]="false" [formGroup]="removalFG"
                                [submitted]="rForm.submitted"></app-select-payment>
          </div>
        </div>
      </div>
    </div>

    <div class="row mb-4 mt-2">
      <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <app-input-general-conditions controlName="generalConditions" [showLabel]="false" [formGroup]="removalFG"
                                      [submitted]="rForm.submitted"></app-input-general-conditions>
      </div>
    </div>

    <div class="row">
      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
        <button type="button" class="btn btn-danger btn-rounded btn-block" (click)="cancel()" i18n="@@cancel">
          Cancel
        </button>
      </div>

      <div class="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 mt-2 mt-md-0 mt-xl-0 mt-xl-0">
        <button type="submit" class="btn btn-success btn-rounded btn-block" i18n="@@validate">Validate</button>
      </div>
    </div>
  </form>
</div>
